import React from 'react';
import logo from '../logo.png';

export default function LoadingSpinner({ 
  size = 80, 
  showText = true,
  loadingMessage = null,
  isArabic = false 
}) {
  // Default loading message if none provided
  const loadingText = loadingMessage || (isArabic ? 'جاري التحميل...' : 'Loading...');
  
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: showText ? 20 : 0
    }}>
      {/* Logo with subtle pulse animation */}
      <img
        src={logo}
        alt="Taealam"
        style={{
          width: size,
          height: size,
          animation: 'pulse 2s ease-in-out infinite',
          objectFit: 'contain',
          filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.1))'
        }}
      />
      
      {/* Loading Message - Below logo */}
      {showText && loadingText && (
        <div style={{
          color: '#6b7280',
          fontSize: size * 0.35,
          fontWeight: 400,
          fontFamily: "'IBM Plex Sans Arabic', sans-serif",
          marginTop: 8,
          opacity: 0.8
        }}>
          {loadingText}
        </div>
      )}
      
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.8;
            transform: scale(0.98);
          }
        }
      `}</style>
    </div>
  );
}

